export class ComboDTO {
    label: string;
    value: string;
    
    constructor() {};
}